import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  .pop-up-content .container {
    margin-top: 3.5rem;
  }
    .content {
        padding: 1rem 2rem;
        .sub-title {
            font-size: 18px;
            font-weight: bold;
        }
        .upgrade-section {
            display: flex;
            justify-content: space-between;
            background-color: rgb(40,133,0,0.1);
            padding: 20px;
            margin: 20px 0;
            max-width: 30rem;
            .btn-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                .ant-btn {
                    background-color: #288500;
                    color: #FFFFFF;
                    border-color: #288500 !important;
                }
            }
            .customize-txt {
                font-weight: bold;
            }
            .customize-txt-wrapper {
                padding-left: 2rem;
            }
        }
        .list-head {
            font-weight: bold;
        }
        .customize-btn {
            margin: 20px 0;
        }
        .blocked-ui {
            .anchor {
                text-decoration: underline;
                margin-left: 5px;
            }
            &:hover {
                .block-ui-message {
                    display: flex;
                }
            }
            &::before {
                background-color: #29292C;
                content: '';
                height: 100%;
                left: 0px;
                opacity: 0.6;
                position: absolute;
                top: 0px;
                width: 100%;
                z-index: 999;
            }
        }
        .block-ui-container {
            position: relative;
            width: 100%;
            margin-top: 2rem;
            padding: 2rem 3rem;
            background: #212121;
            .disable-info {
                margin-top: 1rem;
            }
            .block-ui-message {
                display: none;
                align-items: center;
                    justify-content: center;
                    border: 2px solid #707070;
                    padding: 5px;
                    width: 250px;
                    cursor: pointer;
                    position: absolute;
                    top: 1.5rem;
                    left: 15rem;
                    z-index: 999;
            }
        }
        .button-wrapper {
            display: flex;
            align-items: center;
            .divider {
                margin: 0.25rem;
            }
        }
    }
    .DIY-info {
        margin-top: 1rem;
    }
    /* .border-bottom {
        border-bottom: 1px solid #A8A8B1;
        width: 7rem;
    } */
    .content-divider {
        border-bottom: 1px solid #A8A8B1;
        // width: 75%;
        margin-top: 5rem;
    }
    .sub-content {
        margin: 1.5rem 0;
        background-color: #212121;
        padding: 2rem 3rem;
    }
    .card-container {
        padding: 2rem 0rem;
        /* border-bottom: 1px solid #A8A8B1; */
        /* margin-bottom: 0.5rem; */
        width: fit-content;
        height: 15rem;
        .card {
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 8rem;
            width: 16rem;
            margin: 1rem;
            border-radius: 15px;
            cursor: pointer;
        }
        .card:hover {
            zoom:1.1;
            margin:3px;
        }
    }
    .flex-center {
		display: flex;
		align-items: center
	}
    .divider {
        margin: 0.5rem;
    }
    .advanced-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 1rem;
        color: #fff;
    }
    .box {
        /* border-bottom: 1px solid #DFDFDF; */
        padding: 2rem 3rem;
        background: #212121;
        /* padding-bottom: 1rem; */
        /* width: fit-content; */
    }
    .reset-btn {
        background-color: #FF0000;
        border-color: #FF0000;
    }
    .small-title {
        font-size: 9px;
        font-weight: bold;
    }
    @media (max-width: 285px) {
        .content{
            .button-wrapper {
                .divider {
                     margin: 0.1rem;
                }
            }
        }
    }
    @media (max-width: 425px) {
        .flex-center {
		    display: block;
            .image-container {
                display: flex;
                justify-content: center;
            }
	    }
    }
    @media(max-width: 960px) {
        .content-divider {
            width: 16rem;
        }
        .content {
            .blocked-ui {
               /* .block-ui-message {
                    display: flex;
                    left: 0rem;
                    top: 4rem;
                    background-color: #DFDFDF;
                }
                &:hover {
                    .block-ui-message {
                        background-color: #DFDFDF;
                        left: 0rem;
                        top: 4rem;
                    }
                } */
            }
        }
    }
    @media(max-width: 550px) {
        .content {
            .blocked-ui {
                &:hover {
                    .block-ui-message {
                        left: auto;
                        height: 20px;
                        top: 10px;
                    }
                }
            }
            .upgrade-section {
                flex-direction: column;
                .btn-wrapper {
                    margin-top: 5px;
                    justify-content: start;
                    padding-left: 2rem;
                }
            }
        }
    }
    @media(max-width: 400px) {
        .content {
            .blocked-ui {
                &:hover {
                    .block-ui-message {
                        left: auto;
                        height: 20px;
                        top: 0px;
                        font-size: 10px;
                        width: auto;
                    }
                }
            }
        }
    }
    @media(max-width: 768px) {
        .content {
            .blocked-ui {
                &:hover {
                    .block-ui-message {
                        height: 10%;
                        font-size: 12px;
                        width: auto;
                    }
                }
            }
        }
    }
    @media(max-width: 1880px) and (min-width: 768px) {
        .content {
            .blocked-ui {
                &:hover {
                    .block-ui-message {
                        height: 13%;
                        top: 12%;
                    }
                }
            }
        }
    }
`;

export const ModelWrapper = styled.div`
    color: #fff;
    
    .title {
        font-size: 18px;
        font-weight: bold;
    }
    .content-title {
        font-weight: bold;
    }
    .content-wrapper {
        color: #fff;
        margin: 0.75rem 0rem;
        .ant-input {
            width: 65%;
        }
        .ant-btn {
            width: 100%;
        }
    }
    .btn-wrapper {
        display: flex;
        margin: 2rem 0rem 1rem;
        .ant-btn {
            flex: 1;
        }
        .divider {
            margin: 0.25rem;
        }
    }
    .warning-text {
        margin-top: 1rem;
    }
    .description-content {
        margin: 1rem 0rem;
    }
    .description-header {
        position: relative;
        bottom: 1.25rem;
        background-color: #ffffff;
        padding: 0px 5px;
    }
    .description-box {
        border: 1px solid #A8A8B1;
        display: flex;
        flex-direction: column;
        padding: 0.5rem 1rem;
        margin: 1rem 0rem;
    }
    .warning-wrapper {
        display: flex;
        color: #f83e18;
        margin-top: 10px;
        background-color: #212121;
        align-items: center;
        .anticon {
            margin: 5px;
        }
    }
    .git-icon {
        text-align: center;
        margin: 2rem 0;
    }
    .divider {
        margin: 0.25rem;
    }
    .warning-icon {
        font-size: 2rem;
        padding: 0 10px;
    }
    .non-live-wrapper {
		.description {
			margin: 0.5rem 0rem;
		}
        .list-title {
            font-size: 18px;
            font-weight: bold;
        }
        .back-btn {
            margin-top: 2rem;
            width: 100%;
        }
		.list-icon {
			height: 4rem;
			width: 4rem;
		}
        .exchange-link {
            display: flex;
            flex-direction: column;
        }
    }
`;

export default Wrapper;